import { defineStore } from "pinia";
import type { VisitStore } from "./types";

const useVisitStore = defineStore("visit", {
  state: (): VisitStore => ({
    visitLoadings: {},
  }),
  actions: {
    setVisitLoading(id: string, loading: boolean) {
      this.visitLoadings[id] = loading;
    },
  },
});

export default useVisitStore;
